import { useMutation } from "react-query";
import http from "infra/http";

function useDeletePrevisaoOrcamentaria() {
  return useMutation(
    (id: string) => http.delete(`/v1/previsao-orcamentaria/${id}`),
    { retry: false }
  );
}

export default useDeletePrevisaoOrcamentaria;
